import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AuthenticatedRepayingStudentDebtIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    // The section has no landing page of its own — send /repaying-student-debt
    // to the first item the sidebar lists under it.
    this.router.replaceWith('authenticated.repaying-student-debt.coaching');
  }
}
